import { Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { BaseComponent } from '../../shared/base-components/base.component';
import { PlateType } from '../../titleregistration/models/enums/plate-type.enum';
import { TitleRegistrationService } from '../../titleregistration/services/titleregistration.service';
import { Vehicle } from '../models/vehicle.model';
import { CustomerManageService } from '../shared/customer-manage.service';
import { LazyLoadEvent } from '../../../node_modules/primeng/api';
import { Table } from 'primeng/table';

@Component({
    selector: 'customer-vehicle',
    templateUrl: './customer-vehicle.html'
})

export class CustomerVehicleComponent extends BaseComponent implements OnChanges {
    @Input() public vehicles: any[];
    @Input() public customerNumber: number;
    @Input() public componentTitle = 'Customer Vehicles';
    @Input() public showOwnershipDate = false;
    @Input() public hideActions = false;
    @Input() public filterEnabled = true;
    @Output() public vehicleSelected: EventEmitter<number> = new EventEmitter<number>();

    public dataStore: any = [];
    public previousPage = -1;
    public previousFliter = '';
    public plateType: PlateType = new PlateType();

    public filterText = '';
    public cols: any[] = [
        { field: 'vin', header: 'VIN' },
        { field: 'modelYear', header: 'Year' },
        { field: 'makeDisplayValue', header: 'Make' },
        { field: 'modelDisplayValue', header: 'Model' },
        { field: 'bodyStyleTypeDisplayValue', header: 'Body Style' },
        { field: 'titleNumber', header: 'Title' },
        { field: 'plateNumber', header: 'Plate Number' },
        { field: 'plateTypeId', header: 'Plate Type' },
        { field: 'registrationEndDate', header: 'Reg Exp' },
        { field: 'fleetExpirationDate', header: 'Fleet Exp' },
        { field: 'indicator', header: 'Indicator' }
    ];
    public totalRecords: number;
    @ViewChild('dt2') vehicleTable: Table;

    constructor(private customerService: CustomerManageService, private titleRegistrationService: TitleRegistrationService) {
        super();
        this.displayResults = false;
    }

    ngOnInit() {
        this.UseHelpContent('#CONTENT/Customer/Customer_Vehicles.htm%3FTocPath%3DCustomer%7C_____3');

        if (this.customerNumber != null) {
            // this.populateVehicles(this.customerNumber, 0);
        } else if (this.vehicles != null) {
            this.displayResults = true;
        }

        if (this.showOwnershipDate) {
            this.cols.push({ field: 'vehicleOwnershipDate', header: 'Ownership From' });
            this.cols.push({ field: 'vehicleOwnershipEndDate', header: 'Ownership To' });
        }
    }

    ngOnChanges() {
        if (this.displayResults) {
            if (this.customerNumber != null) {
                // this.populateVehicles(this.customerNumber, 1);
            }
        }
    }

    populateVehicles(customerNumberId: number, event: LazyLoadEvent) {
        var pageNumber = event.first / 10;

        if (pageNumber > this.previousPage) {
            this.titleRegistrationService.getCustomerVehiclesByPaging(customerNumberId, pageNumber).subscribe(
                result => {
                    this.dataStore.push(...result.result);
                    this.displayResults = true;

                    this.vehicles = this.dataStore.slice(event.first, (event.first + event.rows));

                    if (result.result.length > 0) {
                        this.totalRecords = (pageNumber + 1) * 10 + 1;
                    }
                },
                error => {
                    console.log('error', error);
                });
            this.previousPage = pageNumber;
        } else {
            if (event.globalFilter != null && this.previousFliter != event.globalFilter) {
                this.previousFliter = event.globalFilter;
                this.vehicles = this.dataStore.filter(row => this.filterGlobal(row, event.globalFilter));
            } else {
                // this.filterText = "";
                // this.vehicleTable.reset();
                this.vehicles = this.dataStore.slice(event.first, (event.first + event.rows));
            }
        }
    }

    compareField(rowA, rowB, field: string): number {
        if (rowA[field] == null) {
            return 1;
        } // on considère les éléments null les plus petits
        if (typeof rowA[field] === 'string') {
            return rowA[field].localeCompare(rowB[field]);
        }
        if (typeof rowA[field] === 'number') {
            if (rowA[field] > rowB[field]) {
                return 1;
            } else {
                return -1;
            }
        }
    }

    filterGlobal(row, value) {
        for (let i = 0; i < this.cols.length; i++) {
            let column: any = this.cols[i];
            if (row[column.field] == null) {
                continue;
            }
            let rowValue: String = row[column.field].toString().toLowerCase();
            if (value == null || rowValue.includes(value.toLowerCase())) {
                return true;
            }
        }
        return false;
    }

    getValues(id: number, types: any): string {
        if (id !== undefined && id !== null) {
            return types.FromId(id).displayValue;
        } else {
            return '';
        }
    }

    addAlert() {
        const vehicle = new Vehicle();
        this.vehicles.push(vehicle);
    }

    editAlert(id) {
        console.log(id);
    }

    emitVehicleSelection(vehicleId: number) {
        this.vehicleSelected.emit(vehicleId);
    }

    loadVehiclesLazy(event: LazyLoadEvent) {
        this.populateVehicles(this.customerNumber, event);
    }

    emissionDue(vehicleId: number) {
        let veh = this.vehicles.find(v => v.vehicleId === vehicleId);
        if (veh) {
            return veh.emissionsDue;
        }

        return false;
    }

    soldNoticeExists(vehicleId: number) {
        let veh = this.vehicles.find(v => v.vehicleId === vehicleId);
        if (veh) {
            return veh.soldNoticeExists;
        }

        return false;
    }

    withdrawlExists(vehicleId: number) {
        let veh = this.vehicles.find(v => v.vehicleId === vehicleId);
        if (veh) {
            return veh.withdrawlExists;
        }

        return false;
    }

    hasError(vehicleId: number) {
        let veh = this.vehicles.find(v => v.vehicleId === vehicleId);
        if (veh) {
            return veh.hasError;
        }

        return false;
    }
}
